import { FormControl } from '@angular/forms';

export interface ArticleSearchForm {
  search: FormControl<string | null>;
}
